<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  image: string;
  title: string;
  description: string;
  buttonText: string;
  onClick: () => void;
  loading?: boolean;
  buttonVariant?: 'flat' | 'outlined';
}>();

const imageSrc = computed(() => props.image);
</script>

<template>
  <div
    class="flex flex-col items-start rounded-[16px] bg-tint-0 p-6 shadow-sm sm:flex-row sm:items-center"
  >
    <img
      :src="imageSrc"
      :alt="title"
      class="mb-4 h-[140px] w-[140px] object-contain sm:mb-0 sm:mr-6"
    />
    <div class="flex-1 text-left">
      <h3 class="text-lg font-black text-shade-900">{{ title }}</h3>
      <p class="mt-1 text-base text-shade-900">{{ description }}</p>
      <v-btn
        :loading="loading"
        :variant="buttonVariant"
        :color="buttonVariant === 'flat' ? 'highlight-500' : 'highlight-600'"
        :class="{
          'mt-4': true,
          'rounded-md': true,
          '!font-bold': true,
          '!text-none': true,
          'border-2': buttonVariant === 'outlined',
        }"
        @click="onClick"
      >
        <slot name="buttonIconLeft"></slot>
        {{ buttonText }}
        <slot name="buttonIconRight"></slot>
      </v-btn>
    </div>
  </div>
</template>

<style scoped lang="scss">
.v-btn {
  text-transform: none !important;
  letter-spacing: normal !important;
}
</style>
